import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M11.7875 21C12.5105 21 13.0967 20.4139 13.0967 19.6908C13.0967 18.9677 12.5105 18.3816 11.7875 18.3816C11.0644 18.3816 10.4783 18.9677 10.4783 19.6908C10.4783 20.4139 11.0644 21 11.7875 21Z' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.8631 5.62117C10.1057 5.54794 8.61841 6.98265 8.61841 8.7644C8.61841 9.48745 8.03226 10.0736 7.30921 10.0736C6.58615 10.0736 6 9.48745 6 8.7644C6 5.523 8.69521 2.87564 11.9594 3.00451C15.0092 3.07906 17.5031 5.57589 17.573 8.62673C17.6391 11.0584 16.1636 13.2125 14.0656 14.1011C13.4028 14.4041 13.0697 14.9295 13.0697 15.4675C13.0697 16.1906 12.4836 16.7767 11.7605 16.7767C11.0374 16.7767 10.4513 16.1906 10.4513 15.4675C10.4513 13.7048 11.5803 12.3482 13.0038 11.7076C13.014 11.703 13.0243 11.6985 13.0347 11.6941C14.1729 11.2169 14.9924 10.0264 14.9555 8.69601L14.9553 8.68875L14.9553 8.68875C14.9185 7.03244 13.5448 5.65879 11.8885 5.62198C11.88 5.62179 11.8716 5.62152 11.8631 5.62117Z'
            />
        </SvgIcon>
    );
});
